import { ReactElement } from "react"
import { pushClickSessionCta } from "../../../../utils/gtm"
import doctor from '../../../assets/doctor.webp'
import { Wrapper } from "../wrapper/wrapper"
import { PlainTextProps } from "./plain-text-props"
import * as S from './plain-text-style'

export function PlainText ({ id, name, values, urlBuilder, params }: PlainTextProps): ReactElement {
  return <S.Container id={id}>
    <Wrapper>
      <S.Wrapper>
        <S.TextContainer>
          <h4>{values.title}</h4>
          <div dangerouslySetInnerHTML={{ __html: values.content }}></div>
          <S.Link href={urlBuilder.build(values.button.link, params)} onClick={() => pushClickSessionCta(name)}>{values.button.title}</S.Link>
        </S.TextContainer>
        <img src={values.image || doctor} alt="" />
      </S.Wrapper>
    </Wrapper>
  </S.Container>
}
